import React from "react";
import { SafetyInspectionFacility, safetyInspectionSummaryHelper } from "../../../../amorg-common";
import { Button } from "../../../../designSystem/button/Button";
import { colors } from "../../../../designSystem/colors/color";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../../designSystem/compositeComponents/ListRow";
import { StatusCounter } from "../../../../designSystem/compositeComponents/StatusCounter";
import { Small } from "../../../../designSystem/typography/Body";
import { H3 } from "../../../../designSystem/typography/Heading";
import { getFacilityTypeIcon } from '../../../../utils/facilityHelper';
import { InspectionPanel } from "./InspectionPanel";
import { InspectionPointSelectorModal } from "./InspectionPointSelectorModal";
import { ResponsiveDeviceViewLimiter } from "../../../../designSystem/ResponsiveDeviceViewLimiter";

type FacilityPanelProps = {
    activityId:string,
    locationId:string
    facility:SafetyInspectionFacility,
    onUpdate:()=>void,
    readOnly?:boolean
}

export function FacilityPanel(props:FacilityPanelProps):JSX.Element
{
    const inspections = props.facility.inspectionPoints;
    const [expanded, setExpanded] = React.useState(true);
    const [showEdit, setShowEdit] = React.useState(false);

    const summary = safetyInspectionSummaryHelper.getFacilityInspectionSummary(props.facility);
    let color = colors.text.normal;
    if(summary.total > 0 && summary.total === summary.passed)
        color = colors.text.state.success;
    else if(summary.total > 0 && summary.failed > 0)
        color = colors.text.state.error;

    return (
        <>
            <ListRow
                stripColor={color}
                styleVariant="lightGray"
                level={2}
                icon={getFacilityTypeIcon(props.facility.facilityType.id)}
                childRows={[
                    inspections.map(i =>
                        <InspectionPanel key={i.inspectionResult.id} activityId={props.activityId} inspection={i} />
                    )
                ]}
                collapsed={!expanded}
                onCollapse={
                    inspections.length > 0
                        ? (collapsed)=>setExpanded(!collapsed)
                        : undefined
                }
                content={
                    <Flex gap={24} justifyContent="space-between" alignItems="center" style={{marginLeft:'10px'}}>
                        
                        <Flex gap={24}>
                            <Flex flexDirection="column">
                                <H3 color="gray">{props.facility.name}</H3>
                                <Small>{props.facility.facilityType.name}</Small>
                            </Flex>

                        
                            <ResponsiveDeviceViewLimiter desktop>
                                <Flex flexDirection="row" gap={16} flexWrap="wrap">
                                    <StatusCounter icon='status_ok' iconColor={colors.icon.success} text='Godkendt' count={summary.passed} />
                                    <StatusCounter icon='status_error' iconColor={colors.icon.error} text='Ikke godkendt' count={summary.failed} />
                                    <StatusCounter icon='status_error' iconColor={colors.icon.pending} text='Ikke kontrolleret' count={summary.pending} />
                                </Flex>
                            </ResponsiveDeviceViewLimiter>
                        </Flex>
                            
                        {!props.readOnly &&
                            <div style={{justifySelf:'right'}}>
                                <Button variant={'text'} icon={'navigation_settings'} onClick={() => setShowEdit(true)} />
                                <InspectionPointSelectorModal 
                                    activityId={props.activityId}
                                    locationId={props.locationId}
                                    facility={props.facility}
                                    showModal={showEdit} onClose={()=>setShowEdit(false)}
                                    onUpdate={props.onUpdate} />
                            </div>
                        }
                    </Flex>
                } />
        </> 
    );
}